var exports = {
  "Xf": "ProductAnnouncementBanner__T0TIz0",
  "$0": "ProductAnnouncementBanner__visual__SH1mSP",
  "RM": "ProductAnnouncementBanner__visual--hidden__5Xm22a",
  "AJ": "ProductAnnouncementBanner__visual-animation__upPeuI",
  "_K": "ProductAnnouncementBanner__content__JXt-4M",
  "jm": "ProductAnnouncementBanner__content-title__f3hju8",
  "tz": "ProductAnnouncementBanner__content-label__7R0y0g",
  "k6": "ProductAnnouncementBanner__content-labelIcon__Wclv0e",
  "Hx": "ProductAnnouncementBanner__close__N4-_S3",
  "XI": "ProductAnnouncementBanner__canvas__hr2SM-",
  "dk": "ProductAnnouncementBanner__canvas--hidden__a6iIKG",
  "w_": "ProductAnnouncementBanner--nudge__OdJktY",
  "k5": "ProductAnnouncementBanner__visual--inline__RKLDHY",
  "M4": "ProductAnnouncementBanner__splay__6fo_79",
  "eo": "ProductAnnouncementBanner__splay-ghost__WRBD5F",
  "nu": "ProductAnnouncementBanner-splay__86o8Ix",
};

module.exports = exports;
